import script from "./CookieBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieBanner.vue?vue&type=script&setup=true&lang=js"

import "./CookieBanner.vue?vue&type=style&index=0&id=c5ee6006&lang=scss"

const __exports__ = script;

export default __exports__